import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  container: css`
    display: flex;
    height: 72px;
    z-index: 1199;
    position: sticky;
    transition: top 0.2s ease-out;
    background: ${colors.white};
    svg {
      color: ${colors.prussian};
    }
  `,
  content: css`
    position: relative;
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    width: 100%;
    background-color: ${colors.white};
    padding: 0px 20px 8px 20px;
    border-bottom: 1px solid ${colors.silver};
  `,
  favoriteIconSelected: css`
    color: ${colors.orange800} !important;
  `,
  backButton: css`
    display: flex;
    justify-content: flex-start;
  `,
  shareButton: css`
    display: flex;
    justify-content: flex-end;
  `,
};

export default styles;
